import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bytesToSize',
  standalone: true,
})
export class BytesToSizePipe implements PipeTransform {
  transform(value: number): string {
    if (value === null || isNaN(value) || value < 0) {
      return '0B';
    }

    // Decimal conversion: 1 KB = 1000 bytes, 1 MB = 1000 KB, 1 GB = 1000 MB
    if (value < 1000) {
      return value + ' B';
    } else if (value < 1000 * 1000) {
      return (value / 1000).toFixed(2) + ' KB';
    } else if (value < 1000 * 1000 * 1000) {
      return (value / (1000 * 1000)).toFixed(2) + ' MB';
    } else {
      return (value / (1000 * 1000 * 1000)).toFixed(2) + ' GB';
    }
  }
}
